import request from '@/utils/request'

// 查询省市区地区信息列表
export function listArea(query) {
  return request({
    url: '/sys/area/list',
    method: 'get',
    params: query
  })
}

// 查询省市区地区信息详细
export function getArea(areaId) {
  return request({
    url: '/sys/area/' + areaId,
    method: 'get'
  })
}

// 新增省市区地区信息
export function addArea(data) {
  return request({
    url: '/sys/area',
    method: 'post',
    data: data
  })
}

// 修改省市区地区信息
export function updateArea(data) {
  return request({
    url: '/sys/area',
    method: 'put',
    data: data
  })
}

// 删除省市区地区信息
export function delArea(areaId) {
  return request({
    url: '/sys/area/' + areaId,
    method: 'delete'
  })
}
